<template>
  <div>
    <h2 class="content-heading">
      <i class="si si-share mr-5"></i> Dropshipment kanalen
    </h2>

    <div class="row">
      <div class="col-md-6 col-xl-3" v-for="vendor in vendors" :key="vendor.name">
        <dropshipment-widget :vendor="vendor"></dropshipment-widget>
      </div>
    </div>
  </div>
</template>

<script>
import vendors from './vendors'
import DropshipmentWidget from './DropshipmentWidget'

export default {
  components: { DropshipmentWidget },
  data () {
    return {
      vendors
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// DropshipmentPage.vue?5d83092e